import { render, staticRenderFns } from "./Newspapersperiodicals.vue?vue&type=template&id=54179ea7&"
import script from "./Newspapersperiodicals.vue?vue&type=script&lang=js&"
export * from "./Newspapersperiodicals.vue?vue&type=script&lang=js&"
import style0 from "./Newspapersperiodicals.vue?vue&type=style&index=0&id=54179ea7&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports